import { z } from 'zod';

export const SChatwootMessageAttachment = z.object({
  id: z.number(),
  message_id: z.number(),
  file_type: z.string(),
  account_id: z.number(),
  extension: z.null(),
  data_url: z.string(),
  thumb_url: z.string().nullable(),
  file_size: z.number(),
  width: z.null(),
  height: z.null(),
});
export type TChatwootMessageAttachment = z.infer<
  typeof SChatwootMessageAttachment
>;
